import styled from 'styled-components';
import { TextField } from '@mui/material';

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  width: 100%;
`;

const StyledTextField = styled(TextField)`
  margin: 10px 0;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;

  button {
    height: 35px;
    width: 100px;
    padding: 0;
  }
`;

export {
  FormContainer,
  StyledTextField,
  ActionsRow,
};
